import { Flex } from "antd";
import { FontPreviewText } from "./FontPreview";
import React, { CSSProperties } from "react";
import SelectTag from "components/SelectTag/";

export const FontPreviewWithTag = ({
  fontPath,
  color = "black",
  text,
  label,
  fontSize = 16,
  styles,
}: {
  fontPath: string;
  color?: string;
  text?: string;
  label?: React.ReactNode;
  fontSize?: number;
  styles?: CSSProperties;
}) => {
  return (
    <Flex align="center" justify="space-between" gap={6}>
      <FontPreviewText
        font={fontPath}
        text={text ?? "Example"}
        style={{ fontSize: fontSize, padding: 0 }}
      />
      {label && <SelectTag color={color} label={label} styles={styles} />}
    </Flex>
  );
};
